import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ForAll from './ForAll';
import Auth from '../../utils/auth';

const ForAllRoute = () => {
  const location = useLocation();

  useEffect(() => {
    if (!Auth.loggedIn()) {
      Auth.setReferrer(location.pathname);
    }
  }, [location]);

  // Check if user is logged in first
  if (!Auth.loggedIn()) {
    return <Navigate to="/login" />;
  }

  // If user has FMB_USER role but NOT FMB_ADMIN, redirect to openMenus
  if (Auth.isFmbUser() && !Auth.isFmbAdmin()) {
    return <Navigate to="/openMenus" replace />;
  }

  // Otherwise, show the ForAll component (for non-FMB_USER or FMB_ADMIN users)
  return <ForAll />;
};

export default ForAllRoute;
